import BankAccountFundResponseModel from '@/models/bankaccounts/BankAccountFundResponseModel';

export default class DashboardResponseModel {
    public authorizedOperations: number = 0;
    public bankAccountId: number = 0;
    public bankAccountName: string = '';
    public notes: string = '';
    public debits: number = 0;
    public credits: number = 0;
    public balance: number = 0;
    public availableFunds: number = 0;
    public availableTransactions: number = 0;
    public actualBankBalance: number = 0;
    public actualBankBalanceAsOfDate?: Date;
    public actualBankBalanceDifference: number = 0;
    public createdDateTimeUtc?: Date;
    public createdBy: string = '';
    public totalFundBalance: number = 0;
    public totalFundBalanceDifference: number = 0;

    public funds: BankAccountFundResponseModel[] = [];
}
